// Ниши › Разговор — the questions the cue card asks for this niche, and when not to call.

import { CHECKS } from '@leadg/shared';
import type { DiscoveryQuestion, SetVerticalField, VerticalPatch } from './useVerticals.js';

const WHEN_OPTIONS: readonly { key: string; label: string }[] = [
  { key: 'always', label: 'винаги' },
  { key: 'no_website', label: 'когато няма сайт' },
  { key: 'branches', label: 'когато има няколко обекта' },
  ...CHECKS.map((check) => ({ key: `check:${check}`, label: `при слабост: ${check}` })),
];

function QuestionsEditor({
  questions,
  onChange,
}: {
  questions: DiscoveryQuestion[];
  onChange: (next: DiscoveryQuestion[]) => void;
}) {
  const update = (index: number, patch: Partial<DiscoveryQuestion>) =>
    onChange(questions.map((q, i) => (i === index ? { ...q, ...patch } : q)));

  return (
    <div className="adm__rows">
      {questions.map((question, index) => (
        <div key={index} className="adm__row-edit">
          <select
            className="adm__select"
            value={question.when}
            onChange={(event) => update(index, { when: event.target.value })}
            aria-label="Кога се задава"
          >
            {WHEN_OPTIONS.map((option) => (
              <option key={option.key} value={option.key}>
                {option.label}
              </option>
            ))}
          </select>
          <input
            type="text"
            className="adm__input"
            value={question.text_bg}
            onChange={(event) => update(index, { text_bg: event.target.value })}
            placeholder="Въпросът, както се казва по телефона"
            aria-label="Текст на въпроса"
          />
          <button
            type="button"
            className="adm__json-btn"
            onClick={() => onChange(questions.filter((_q, i) => i !== index))}
            aria-label="Премахни въпроса"
          >
            ×
          </button>
        </div>
      ))}
      <button
        type="button"
        className="adm__json-btn"
        onClick={() => onChange([...questions, { when: 'always', text_bg: '' }])}
      >
        + Въпрос
      </button>
    </div>
  );
}

function DeadHoursEditor({
  hours,
  onChange,
}: {
  hours: Record<string, string>;
  onChange: (next: Record<string, string>) => void;
}) {
  const entries = Object.entries(hours);
  const rebuild = (next: [string, string][]) => onChange(Object.fromEntries(next));

  return (
    <div className="adm__rows">
      {entries.map(([key, text], index) => (
        <div key={index} className="adm__row-edit">
          <input
            type="text"
            className="adm__input adm__input--mono adm__input--short"
            value={key}
            onChange={(event) =>
              rebuild(entries.map((e, i) => (i === index ? [event.target.value, e[1]] : e)))
            }
            placeholder="ключ (lunch)"
            aria-label="Ключ"
          />
          <input
            type="text"
            className="adm__input"
            value={text}
            onChange={(event) =>
              rebuild(entries.map((e, i) => (i === index ? [e[0], event.target.value] : e)))
            }
            placeholder="описание (12:00–13:00)"
            aria-label="Описание"
          />
          <button
            type="button"
            className="adm__json-btn"
            onClick={() => rebuild(entries.filter((_e, i) => i !== index))}
            aria-label="Премахни"
          >
            ×
          </button>
        </div>
      ))}
      <button
        type="button"
        className="adm__json-btn"
        onClick={() => rebuild([...entries, ['', '']])}
      >
        + Период
      </button>
    </div>
  );
}

export function VerticalTalkTab({ draft, set }: { draft: VerticalPatch; set: SetVerticalField }) {
  return (
    <div className="adm__form">
      <fieldset className="adm__fieldset">
        <legend className="adm__legend">Въпроси за разговора</legend>
        <p className="adm__note">
          Влизат в картата за обаждане според условието. „{'{{fact:branch_count}}'}“ се замества с
          броя обекти.
        </p>
        <QuestionsEditor
          questions={draft.discovery_questions}
          onChange={(next) => set('discovery_questions', next)}
        />
      </fieldset>
      <fieldset className="adm__fieldset">
        <legend className="adm__legend">Кога да не се звъни</legend>
        <p className="adm__note">Мъртвите часове на занаята — „Днес“ ги показва до обекта.</p>
        <DeadHoursEditor
          hours={draft.call_dead_hours}
          onChange={(next) => set('call_dead_hours', next)}
        />
      </fieldset>
    </div>
  );
}
